import MascotAvatar from "./MascotAvatar";
import { CAST } from "./mascotMood";

// Namey on the left with whatever it's saying in a speech bubble.
export default function NameySays({ mood = "happy", size = 40, children, className = "" }) {
  return (
    <div className={`flex items-start gap-3 ${className}`}>
      <div className="flex-shrink-0 pt-1">
        <MascotAvatar key={mood} mascot={CAST.namey} mood={mood} size={size} shadow={false} className="nm-pop" />
      </div>
      <div className="relative flex-1 min-w-0 rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3">
        <span
          aria-hidden="true"
          className="absolute -left-[7px] top-5 h-3 w-3 rotate-45 border-b border-l border-gray-200 bg-gray-50"
        />
        {children}
      </div>
    </div>
  );
}
